"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInitializing = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const constants_1 = require("../../constants");
require("./types");
exports.AppInitializing = react_1.default.memo(({ message }) => {
    return (react_1.default.createElement(components_1.StackView, { "data-selector-id": "app-initializing", align: components_1.STACK_ALIGN.center, distribution: components_1.STACK_DISTRIBUTION.center, gap: components_1.STACK_GAP.m, size: {
            height: '100%',
        } },
        react_1.default.createElement(components_1.Spinner, { size: constants_1.SPINNER_SIZES.xxl }),
        message && (react_1.default.createElement(components_1.Text, { "data-selector-id": "app-initializing-message", size: components_1.TEXT_SIZE.xl }, message))));
});
exports.AppInitializing.displayName = 'AppInitializing';
//# sourceMappingURL=AppInitializing.js.map